import { render } from "./payment-history.vue?vue&type=template&id=54c43b49"
import script from "./payment-history.vue?vue&type=script&lang=js"
export * from "./payment-history.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__